import ILoanDrawdownCondition from './ILoanDrawdownCondition';
import ILoanDrawdownConditionDocument from './ILoanDrawdownConditionDocument';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseLoanDrawdownCondition(raw: any): ILoanDrawdownCondition {
    return {
        createdTime: raw.createdTime,
        loanDrawdownUuid: raw.loanDrawdownUuid,
        name: raw.name,
        uuid: raw.uuid,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseLoanDrawdownConditionDocument(raw: any): ILoanDrawdownConditionDocument {
    return {
        createdTime: raw.createdTime,
        fileName: raw.fileName,
        loanDrawdownConditionUuid: raw.loanDrawdownConditionUuid,
        uuid: raw.uuid,
    };
}
